export const SRHT_EXAM_TAB_MANAGE = 'manage';
export const SRHT_EXAM_TAB_REGULATION = 'regulation';
export const SRHT_EXAM_TAB_WRITTEN = 'written';
export const SRHT_EXAM_TAB_SHEETS = 'sheets';
export const SRHT_EXAM_TAB_FINAL = 'final';

export function getVisibleSrhtExamTabs(permissions = {}) {
  const visibleTabs = [];

  if (permissions.canManageAdministration) {
    visibleTabs.push(SRHT_EXAM_TAB_MANAGE);
  }

  if (permissions.canAccessModule) {
    visibleTabs.push(SRHT_EXAM_TAB_REGULATION);
  }

  if (permissions.canViewWrittenExam) {
    visibleTabs.push(SRHT_EXAM_TAB_WRITTEN);
  }

  if (permissions.canAccessEvaluationTabs) {
    visibleTabs.push(SRHT_EXAM_TAB_SHEETS);
  }

  if (permissions.canViewFinalEvaluation) {
    visibleTabs.push(SRHT_EXAM_TAB_FINAL);
  }

  return visibleTabs;
}